var wallet = require('./src/wallet.js')

module.exports = wallet



//////////////////
// WEBPACK FOOTER
// ./node_modules/@beqdev/wallet.js/index.js
// module id = tb8W
// module chunks = 0